const Cstr = () => import("./views/cstr.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/cstr",
      component: Cstr,
      name: "Cstr",
      meta: {
        groupName: "QC & QA",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
